// angular references
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
registerLocaleData(localeNl);

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, InjectionToken } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader/';
import { TranslateLoader } from '@ngx-translate/core';

// modules
import { AppRoutingModule } from './app-routing.module';

// components
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { RegistrationComponent } from './pages/registration/registration.component';
import { CheckUserComponent } from './pages/check-user/check-user.component';
import { FormQuestionComponent } from './components/form-question/form-question.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { RegistrationCompleteComponent } from './pages/registration-complete/registration-complete.component';
import { VerifyTokenComponent } from './pages/verify-token/verify-token.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiselectControlComponent } from './components/multiselect-control/multiselect-control.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { CaptchaComponent } from './components/captcha/captcha.component';

// services
import { ProfileService } from './services/profile.service';
import { FormsService } from './services/forms.service';
import { LoadingIndicatorService } from './services/loading-indicator.service';
import { EventService } from './services/event.service';
import { TokenVerificationService } from './services/token-verification.service';

// directives
import { RecaptchaDirective } from './directives/recaptcha.directive';
import { ValidDateDirective } from './directives/valid-date.directive.directive';
import { KvkSearchComponent } from './components/kvk-search/kvk-search.component';
import { CopyrightComponent } from './pages/about/copyright/copyright.component';
import { PrivacyComponent } from './pages/about/privacy/privacy.component';
import { CookiesComponent } from './pages/about/cookies/cookies.component';
import { AccessabilityComponent } from './pages/about/accessability/accessability.component';
import { ArchiveComponent } from './pages/about/archive/archive.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/language/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    RegistrationComponent,
    CheckUserComponent,
    FormQuestionComponent,
    LanguageSelectorComponent,
    LoadingIndicatorComponent,
    DialogComponent,
    RegistrationCompleteComponent,
    VerifyTokenComponent,
    ErrorPageComponent,
    LoaderComponent,
    CaptchaComponent,
    RecaptchaDirective,
    MultiselectControlComponent,
    ValidDateDirective,
    KvkSearchComponent,
    CopyrightComponent,
    PrivacyComponent,
    CookiesComponent,
    AccessabilityComponent,
    ArchiveComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    ProfileService,
    FormsService,
    LoadingIndicatorService,
    EventService,
    TokenVerificationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
